import { SIZE_50 } from '@/lib/gridElements/size';
import { FACEBOOK } from '@/lib/socialProfile';

import { BubbleMapChart } from '@/components/composite/Charts/BubbleMapChart';

export const citiesDistributionConfig = {
    height: 300,
    name: {
        city: 'chart.facebook.cities_distribution_city',
        value: 'chart.facebook.cities_distribution_value',
        lat: 'chart.facebook.cities_distribution_lat',
        lng: 'chart.facebook.cities_distribution_lng',
        percentage: 'percentage'
    },
    defaultTableSorting: [{ id: 'value', desc: true }],
    social: FACEBOOK,
    tooltip: 'chart.facebook.cities_distribution_tooltip',
    noLegend: true,
    datePickerDoesNotApply: true,
    id: 'cities_distribution',
    size: SIZE_50,
    title: 'chart.facebook.cities_distribution_fans',
    type: 'chart',
    element: BubbleMapChart,
    defaultFilter: 'global'
};
